export const admindetails = {
    phone: "+254791412410",
    email: "agunyobill2017@gmail.com",
    username: "Eazistey Admin",
    ownerurl: "https://eazistey.co.ke/API_WEB_HOOKS/images/mainadmin.png"
};

//default image placeholder
export const imageplaceholder = "https://eazistey.co.ke/API_WEB_HOOKS/images/image2.png";

//google client id
export const googleclientid = "862869639404-b5tpojr7vfs5b0phig2ijf9ke63cf215.apps.googleusercontent.com"